export const PageEnum = {
  // basic login path
  BASE_LOGIN: ['/login'],
  // basic home path
  // BASE_HOME: '/',
  BASE_HOME: '/authorized_list',
  // error page path
  // ERROR_PAGE = '/exception',
}
